import { render, staticRenderFns } from "./Url_v1.vue?vue&type=template&id=5bcd26df&scoped=true&lang=pug"
import script from "./Url_v1.vue?vue&type=script&lang=js"
export * from "./Url_v1.vue?vue&type=script&lang=js"
import style0 from "./Url_v1.vue?vue&type=style&index=0&id=5bcd26df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd26df",
  null
  
)

export default component.exports